// Convex URL, injected at build time by build.ts via `define`.
//
// Reads process.env.PUBLIC_* rather than import.meta.env, which is a bundler
// construct Bun does not provide: it survives into the browser as undefined,
// so the previous import.meta.env form always silently fell through to the
// fallback and no Vercel env var could ever reach the bundle.
//
// The fallback keeps the app booting if the variable is missing, but it is a
// safety net rather than the normal path — a build that lands on it logs a
// MISSING line (see clientEnv in build.ts).

/**
 * Pulls the URL out of whatever the env var actually contains.
 *
 * A dashboard env var is typed by hand, and a value of
 * `CONVEX_URL = https://…` — the whole line pasted in, name and all — took the
 * site down: the Convex client rejects the address and the React tree dies on
 * an uncaught error, so the page renders blank. Tolerating that costs one
 * regex and turns a total outage into a working site.
 */
function readConvexUrl(raw: string | undefined): string {
  const trimmed = raw?.trim() ?? "";
  if (trimmed.startsWith("https://")) return trimmed;
  return trimmed.match(/https:\/\/\S+/)?.[0] ?? "";
}

export const CONVEX_URL =
  readConvexUrl(process.env.PUBLIC_CONVEX_URL) ||
  "https://quixotic-salmon-154.convex.cloud";
